/**
 * Created by asiulik on 20.12.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter'], function($, _, EventEmitter){

    var config = {
        sliderTriggerSelector: "[data-slider-overlay-trigger]",
        sliderModuleSelector: ".m__slider-with-gallery",
        sliderOverlaySelector: "[data-slider-overlay]"
    };

    function OverlaySlider(overlayInstance){
        this.overlay = overlayInstance;
    }

    OverlaySlider.prototype = _.clone(EventEmitter.prototype);

    OverlaySlider.prototype.init = function(){

        this.$triggerElements = $(config.sliderTriggerSelector);
        this.$slider = $($(config.sliderModuleSelector).find('.slider'));
        this.bindEvents();

    };

    OverlaySlider.prototype.bindEvents = function(){

        var _this = this;

        this.$triggerElements.on({
            click: function(e){

                e.preventDefault();
                var $this = $(this);

                if( e.target === e.currentTarget ) {
                    _this.openClosestSliderOverlay($this);
                }

            }
        })

    };

    OverlaySlider.prototype.openClosestSliderOverlay = function($triggerElement){

        var $currentSliderContainer = $triggerElement.closest(config.sliderModuleSelector);

        var triggerElements = $currentSliderContainer.find(config.sliderTriggerSelector);

        var currentClickedElement = triggerElements.filter(function(index, element){
            return element == $triggerElement.get(0)
        });

        var index = triggerElements.toArray().indexOf(currentClickedElement[0]);

        var $sliderContainer = $($currentSliderContainer.find('.slider'));

        this.synchronizeSliderInOverlay($sliderContainer, index || 0);

        this.overlay.openOverlay(
            $currentSliderContainer.find(
                config.sliderOverlaySelector
            )
        );

    };

    OverlaySlider.prototype.synchronizeSliderInOverlay = function($sliderContainer, sliderIndex) {
        if($sliderContainer){
            $sliderContainer.slick('slickGoTo', sliderIndex, true);
        }
    };

    return OverlaySlider

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/overlays/overlaySlider.js